/* Publish by EComposer at 2026-10-17 14:23:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fe2tiiv2x0m"]=  window.__ectimmers["ecom-fe2tiiv2x0m"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-fe2tiiv2x0m"]["e8coa14hv"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-fe2tiiv2x0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fe2tiiv2x0m', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-g61d0d880fm"]=  window.__ectimmers["ecom-g61d0d880fm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-g61d0d880fm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g61d0d880fm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-567tbogx1va').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-567tbogx1va', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xks5cxysb6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xks5cxysb6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bgnemor0wl5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bgnemor0wl5', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}